import { createSlotsContext } from '@grandvisionhq/slots';

const [ProductBlockSlotsProvider, useProductBlockSlots] = createSlotsContext({
    displayName: 'ProductBlockContext'
});

export { ProductBlockSlotsProvider, useProductBlockSlots };
//# sourceMappingURL=context.js.map
